// @flow
import React, { Component } from 'react';
import { type FieldProps } from 'redux-form';
import { Textarea, TextareaDiv } from './TextareaInputStyles';
import { InputValidationSmall } from './InputStyles';

type Props = {
  ...$Exact<FieldProps>,
  label: string,
  disabled?: boolean,
  placeholder?: string,
  meta?: { error?: string }
};

export default class TextareaInput extends Component<Props> {
  static defaultProps = {
    disabled: false,
    label: ''
  };

  render() {
    return (
      <TextareaDiv meta={this.props.meta}>
        <label>{this.props.label}</label>
        <Textarea
          {...this.props.input}
          meta={this.props.meta}
          disabled={this.props.disabled}
          placeholder={this.props.placeholder}
        />
        <InputValidationSmall meta={this.props.meta}>
          {this.props.meta && this.props.meta.error}
        </InputValidationSmall>
      </TextareaDiv>
    );
  }
}
